import React from 'react';
import EditorFontFamily from '@wix/da-ds/pkg/Icons/24x24/EditorFontFamily';
import { useTranslation } from 'react-i18next';
import { isExtensionInstalled } from '../../utils/tiptap';
import { webSafeFonts } from '../../Editor/constants';
import EditorIconButtonWithContextMenu from '../_partials/EditorIconButtonWithContextMenu';
const FontFamily = ({ editor, hideWhenNotEnabled = true })=>{
    const { t } = useTranslation('editor');
    if (!editor.isEditable || hideWhenNotEnabled && !isExtensionInstalled(editor, 'textFont')) {
        return null;
    }
    const fontItems = [];
    for(const key in webSafeFonts){
        fontItems.push({
            featureId: `format:font:${webSafeFonts[key]}`,
            label: /*#__PURE__*/ React.createElement("span", {
                style: {
                    fontFamily: `${webSafeFonts[key]}`,
                    fontWeight: editor.isActive('textStyle', {
                        fontFamily: `${webSafeFonts[key]}`
                    }) ? 'bold' : ''
                }
            }, key),
            selected: editor.isActive('textStyle', {
                fontFamily: `${webSafeFonts[key]}`
            }),
            onClick: ()=>{
                editor.chain().focus().setFontFamily(`${webSafeFonts[key]}`).run();
            }
        });
    }
    return /*#__PURE__*/ React.createElement(EditorIconButtonWithContextMenu, {
        // reusing textAlign here as its the same logic and means we don't need to dupe the tiptap exts
        disabled: !editor.can().chain().focus().setTextAlign('center').run(),
        featureId: "format:font",
        icon: EditorFontFamily,
        tooltipText: t('button.fontfamily.tooltip'),
        "aria-label": t('button.fontfamily.tooltip'),
        items: [
            {
                featureId: "format:font:default",
                label: t('button.fontfamily.default'),
                selected: !editor.isActive('textStyle'),
                onClick: ()=>{
                    editor.chain().focus().unsetFontFamily().run();
                }
            },
            ...fontItems
        ]
    });
};
FontFamily.displayName = 'FontFamily';
export default FontFamily;

//# sourceMappingURL=FontFamily.js.map